import React, { useEffect } from 'react'
import '../../assets/css/salesforce.css'

const MVPDevelopment = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    MVP Development Services
                                </h1>
                                <p className="breadcrumb-subtitle text-white">
                                    Transform your innovative ideas into market-ready products with our expert MVP development services.<br /> Build, test, and validate your concepts faster with our agile development approach.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Our MVP</span> Development Approach
                                </h2>-
                                <p className="ai-driven-description">
                                    CLOUD MIND X specializes in Minimum Viable Product (MVP) development, helping startups and enterprises validate their business ideas quickly and cost-effectively. Our experienced team combines cutting-edge technology with lean methodology to deliver functional prototypes that capture market attention and drive user engagement.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src={require('../../assets/images/mvp.png')}
                                    alt="MVP Development"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* MVP Services Section */}
            <section className="salesforce-services-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-services-title">
                                Our <span className="text-gradient">MVP Development</span> Services
                            </h2>
                            <p className="salesforce-services-subtitle">
                                End-to-end MVP development solutions designed to accelerate your product journey from concept to market validation
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Service Card 1 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">MVP Strategy & Planning</h3>
                                <p className="sf-service-description">
                                    Comprehensive market research and strategic planning to define your MVP scope. We identify core features, target audience, and success metrics to ensure your product addresses real market needs and delivers measurable value.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 2 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 6V18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M3 12H21" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Rapid Prototyping</h3>
                                <p className="sf-service-description">
                                    Quick development of functional prototypes using modern frameworks and tools. Our agile approach ensures fast iteration cycles, allowing you to test concepts and gather user feedback early in the development process.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 3 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">UI/UX Design</h3>
                                <p className="sf-service-description">
                                    User-centered design that creates intuitive and engaging interfaces. Our design team crafts pixel-perfect user experiences that not only look great but also drive user engagement and conversion through thoughtful interaction design.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 4 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="16" height="16" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4 10H20" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Agile Development</h3>
                                <p className="sf-service-description">
                                    Iterative development using Scrum and Kanban methodologies. We break down complex projects into manageable sprints, ensuring continuous delivery of working software and regular stakeholder feedback throughout the development cycle.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 5 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Testing & Quality Assurance</h3>
                                <p className="sf-service-description">
                                    Comprehensive testing strategies including automated testing, user acceptance testing, and performance optimization. We ensure your MVP is robust, scalable, and ready for real-world deployment with minimal bugs and maximum reliability.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 6 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 1V3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M12 21V23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 4.22L5.64 5.64" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 18.36L19.78 19.78" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M1 12H3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M21 12H23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 19.78L5.64 18.36" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 5.64L19.78 4.22" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Launch & Validation</h3>
                                <p className="sf-service-description">
                                    Strategic product launch and market validation services. We help you deploy your MVP, collect user feedback, analyze performance metrics, and make data-driven decisions for future iterations and scaling.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 7 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 22V12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7 9.5L2 12V17L12 22L22 17V12L17 9.5" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Post-Launch Support</h3>
                                <p className="sf-service-description">
                                    Ongoing maintenance and support services to keep your MVP running smoothly. We provide regular updates, bug fixes, performance monitoring, and feature enhancements based on user feedback and market demands.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 8 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Scaling & Iteration</h3>
                                <p className="sf-service-description">
                                    Strategic planning for product scaling and feature expansion. Based on MVP validation results, we help you iterate on successful features, expand your user base, and transform your MVP into a full-fledged product.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* MVP Technologies Section */}
            <section className="salesforce-clouds-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-3">
                            <h2 className="salesforce-clouds-title">
                                Technologies <span className="text-gradient">We Use</span>
                            </h2>
                            <p className="salesforce-clouds-subtitle">
                                Cutting-edge technologies and frameworks to build robust, scalable MVPs that stand out in the market
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* React */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00D4FF" />
                                        <path d="M18 24L22 28L30 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">React</h3>
                            </div>
                        </div>

                        {/* Node.js */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FF6B9D" />
                                        <path d="M24 14C28.4183 14 32 17.5817 32 22C32 26.4183 28.4183 30 24 30C19.5817 30 16 26.4183 16 22C16 17.5817 19.5817 14 24 14Z" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 30V34" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Node.js</h3>
                            </div>
                        </div>

                        {/* Python */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A1E0" />
                                        <path d="M14 24L20 18L26 24L34 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M28 16H34V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Python</h3>
                            </div>
                        </div>

                        {/* Flutter */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#A78DFF" />
                                        <circle cx="24" cy="18" r="4" stroke="white" strokeWidth="2.5" />
                                        <circle cx="16" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                        <circle cx="32" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Flutter</h3>
                            </div>
                        </div>

                        {/* AWS */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#8B5CF6" />
                                        <path d="M16 20H32M16 20V30H32V20M16 20L24 14L32 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M24 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M28 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">AWS</h3>
                            </div>
                        </div>

                        {/* MongoDB */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FFA726" />
                                        <path d="M24 14L19 19V32H29V19L24 14Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19 22H29" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">MongoDB</h3>
                            </div>
                        </div>

                        {/* Docker */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A8E1" />
                                        <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 16V14M24 34V32M16 24H14M34 24H32" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Docker</h3>
                            </div>
                        </div>

                        {/* Firebase */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#10B981" />
                                        <path d="M16 18L20 14L24 18L28 14L32 18V30C32 31.1046 31.1046 32 30 32H18C16.8954 32 16 31.1046 16 30V18Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Firebase</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="salesforce-contact-section">
                <div className="salesforce-contact-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="salesforce-contact-content">
                                <h2 className="salesforce-contact-title">Ready to Build Your MVP?</h2>
                                <p className="salesforce-contact-description">
                                    Transform your innovative idea into a market-ready product. Our expert team is ready to help you navigate the MVP development journey from concept to launch.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <button className="salesforce-contact-btn">
                                Start Your Project
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default MVPDevelopment;
